/* eslint-disable */
<template>
  <section>
    <div :style="{ textAlign: 'center', paddingTop: '75px' }" v-if="loading">
      <h3>Loading Campaign...</h3>
    </div>
    <iframe class="mail-body" v-else ref="mailBody" width="100%" frameborder="0"></iframe>
  </section>
</template>

<script>
import Api from "@/services/Api.js";
import { setTimeout } from 'timers';
export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    getTemplate() {
      this.loading = true;
      const campaignId = this.$route.params.campaignId;
      const subscriberId = this.$route.params.subscriberId;
      let path = `campaigns/${campaignId}/view/`;

      if (subscriberId) {
        path += subscriberId;
      }

      Api.get(path).then(res => {
        this.loading = false;
        let { template:html, subject } = res.data.data;
        if (subject && subject !== '') {
          document.title = subject;
        }
        this.$nextTick(() => {
          let iframeWindow = this.$refs.mailBody;
          let iframeBody = iframeWindow.contentDocument.body;
          iframeWindow.srcdoc = html;
          iframeBody.style = 'margin:0px';
          setTimeout(() => {
            document.querySelector('iframe').contentDocument.body.querySelectorAll('a').forEach((node) => {
              node.setAttribute('target', '_blank')
            });
          }, 500);
        });
      });
    }
  },

  created() {
    this.getTemplate();
  }
};
</script>

<style lang="scss" scoped>
  html, body {
    margin: 0;
    padding: 0;
  }
  .mail-body {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
  }
</style>